export const GET_FILTERS = "/dashboard/filters"
